import React from "react";

const Loading = ({ size = "16", color = "#EE5222" }) => {
  return (
    <div className="flex justify-center items-center h-screen">
      <div
        className={`animate-spin rounded-full border-t-4 border-solid`}
        style={{
          height: `${size * 4}px`,
          width: `${size * 4}px`,
          borderColor: color,
        }}
      ></div>
    </div>
  );
};

export default Loading;
